import React from 'react';
import { Box } from '@material-ui/core';
import MainGroupStyled from './MainGroupStyled';
import CommonGroup from '../common_group/CommonGroup';

const MainGroup = ({ list = [] }) => {
  return (
    <MainGroupStyled>
      <Box className="main_content">
        {list.length > 0
          ? list.map((item, index) => (
              <Box className="card_content">
                <CommonGroup key={index} obj={item}></CommonGroup>
              </Box>
            ))
          : null}
      </Box>
    </MainGroupStyled>
  );
};

export default MainGroup;
